export enum CollectionType {
  QUERY = 'query',
  CHERRY_PICK = 'cherryPick',
}
